(function () {
  var STORAGE_KEY = 'tz:breadcrumb-path:v1';
  var PRODUCT_KEY_PREFIX = 'tz:breadcrumb-product:';
  var MAX_AGE = 1000 * 60 * 60 * 4;

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function cleanUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.pathname + parsed.search;
    } catch (error) {
      return url.charAt(0) === '/' ? url : '/' + url;
    }
  }

  function readJson(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function isFresh(record) {
    return record && record.savedAt && now() - record.savedAt < MAX_AGE;
  }

  function normalizeItem(item) {
    var title = cleanText(item && item.title);
    var url = cleanUrl(item && item.url);
    if (!title || !url || url === '/') return null;
    return { title: title, url: url };
  }

  function uniquePath(items) {
    var seen = {};
    var result = [];
    (items || []).forEach(function (item) {
      var clean = normalizeItem(item);
      if (!clean || seen[clean.url]) return;
      seen[clean.url] = true;
      result.push(clean);
    });
    return result.slice(-3);
  }

  function getCollectionPath(nav) {
    var items = [];
    var crumbLinks = nav ? nav.querySelectorAll('[data-tz-breadcrumb-list] a[href*="/collections/"]') : [];
    crumbLinks.forEach(function (link) {
      items.push({ title: link.textContent, url: link.getAttribute('href') });
    });

    if (!items.length && nav && nav.dataset.tzCollectionTitle && nav.dataset.tzCollectionUrl) {
      items.push({ title: nav.dataset.tzCollectionTitle, url: nav.dataset.tzCollectionUrl });
    }

    return uniquePath(items);
  }

  function productHandleFromUrl(url) {
    var match = cleanUrl(url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function storeCollectionPath(nav) {
    var path = getCollectionPath(nav);
    if (!path.length) return;
    writeJson(STORAGE_KEY, {
      path: path,
      source: 'collection',
      collectionUrl: path[path.length - 1].url,
      savedAt: now()
    });
  }

  function storeProductClick(link) {
    var handle = productHandleFromUrl(link.getAttribute('href'));
    if (!handle) return;
    var record = readJson(STORAGE_KEY);
    if (!isFresh(record) || !record.path || !record.path.length) return;
    writeJson(PRODUCT_KEY_PREFIX + handle, {
      path: record.path,
      productHandle: handle,
      source: 'product-click',
      savedAt: now()
    });
  }

  function fallbackPath(nav) {
    var items = [];
    if (nav.dataset.tzContextCollectionTitle && nav.dataset.tzContextCollectionUrl) {
      items.push({ title: nav.dataset.tzContextCollectionTitle, url: nav.dataset.tzContextCollectionUrl });
    }
    if (nav.dataset.tzMainCollectionTitle && nav.dataset.tzMainCollectionUrl) {
      items.push({ title: nav.dataset.tzMainCollectionTitle, url: nav.dataset.tzMainCollectionUrl });
    }
    if (nav.dataset.tzSubCollectionTitle && nav.dataset.tzSubCollectionUrl) {
      items.push({ title: nav.dataset.tzSubCollectionTitle, url: nav.dataset.tzSubCollectionUrl });
    }
    if (!items.length && nav.dataset.tzFallbackCollectionTitle && nav.dataset.tzFallbackCollectionUrl) {
      items.push({ title: nav.dataset.tzFallbackCollectionTitle, url: nav.dataset.tzFallbackCollectionUrl });
    }
    return uniquePath(items);
  }

  function productBelongsToPath(nav, path) {
    if (!path || !path.length) return false;
    var urls = [
      nav.dataset.tzContextCollectionUrl,
      nav.dataset.tzMainCollectionUrl,
      nav.dataset.tzSubCollectionUrl,
      nav.dataset.tzFallbackCollectionUrl
    ].map(cleanUrl).filter(Boolean);
    if (!urls.length) return true;
    return path.some(function (item) {
      return urls.indexOf(cleanUrl(item.url)) !== -1;
    });
  }

  function renderProductBreadcrumb(nav, path) {
    var list = nav.querySelector('[data-tz-breadcrumb-list]');
    if (!list) return;
    var productTitle = cleanText(nav.dataset.tzProductTitle);
    var homeText = list.querySelector('a') ? cleanText(list.querySelector('a').textContent) : 'Home';
    var html = '<li><a href="/">' + escapeHtml(homeText || 'Home') + '</a></li>';

    uniquePath(path).forEach(function (item) {
      html += '<li><a href="' + escapeAttr(cleanUrl(item.url)) + '">' + escapeHtml(item.title) + '</a></li>';
    });

    html += '<li><span aria-current="page" class="tz-breadcrumb-current">' + escapeHtml(productTitle) + '</span></li>';
    list.innerHTML = html;
    nav.setAttribute('data-tz-breadcrumb-ready', 'true');
  }

  function escapeHtml(value) {
    return cleanText(value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function escapeAttr(value) {
    return String(value || '').replace(/"/g, '&quot;');
  }

  function applyProductPath(nav) {
    var handle = nav.dataset.tzProductHandle || productHandleFromUrl(window.location.pathname);
    var direct = readJson(PRODUCT_KEY_PREFIX + handle);
    var sessionPath = isFresh(direct) ? direct.path : null;
    var globalRecord = readJson(STORAGE_KEY);

    if (!sessionPath && isFresh(globalRecord) && productBelongsToPath(nav, globalRecord.path)) {
      sessionPath = globalRecord.path;
    }

    var path = productBelongsToPath(nav, sessionPath) ? sessionPath : null;
    if (!path || !path.length) path = fallbackPath(nav);
    if (path && path.length) renderProductBreadcrumb(nav, path);
  }

  function init() {
    var nav = document.querySelector('[data-tz-breadcrumb]');
    if (nav && nav.dataset.tzTemplate === 'collection') {
      storeCollectionPath(nav);
    }
    if (nav && nav.dataset.tzTemplate === 'product') {
      applyProductPath(nav);
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (link) storeProductClick(link);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function () {
    var nav = document.querySelector('[data-tz-breadcrumb][data-tz-template="product"]');
    if (nav) applyProductPath(nav);
  });
})();
